import { Grid, Bones } from '@simplywallst/ui-core';
import { FeedCardItemSkeleton } from './FeedCardItemSkeleton';

import { Wrapper, Header, StyledFeedCards } from './styled';

export const FeedCardSkeleton = () => (
  <Wrapper data-cy-id="dashboard-feed-skeleton">
    <Header>
      <Grid
        gap="12px"
        templateColumns="40px auto"
        alignItems="start"
        borderTopLeftRadius="x1"
        borderTopRightRadius="x1"
        paddingX="x2"
        paddingY="x1_5"
      >
        <div>
          <Bones borderRadius="x5" minHeight="40px" minWidth="40px" />
        </div>
        <Grid rowGap="8px">
          <Grid templateColumns="repeat(2, 40px)" gap="8px">
            <Bones maxHeight="20px" maxWidth="40px" />
            <Bones maxHeight="40px" maxWidth="40px" />
          </Grid>
          <Bones maxHeight="40px" maxWidth="40px" />
          <Grid templateColumns="repeat(4, 40px)" gap="4px">
            <Bones maxHeight="10px" maxWidth="40px" />
            <Bones maxHeight="10px" maxWidth="40px" />
            <Bones maxHeight="10px" maxWidth="40px" />
            <Bones maxHeight="10px" maxWidth="40px" />
          </Grid>
        </Grid>
      </Grid>
    </Header>

    <StyledFeedCards>
      <FeedCardItemSkeleton />
    </StyledFeedCards>
  </Wrapper>
);
